<template>
  <div
    id="app"
    :class="{
      'router-home': $route.fullPath === '/',
      'router-engineering': $route.fullPath === '/engineering',
      'router-about': $route.fullPath === '/about',
      'router-design': $route.fullPath === '/design',
      'router-changelog': $route.fullPath === '/changelog'
    }"
  >
    <Navbar />
    <main role="main">
      <transition name="fade">
        <router-view />
      </transition>
    </main>
    <Footer />
    <CookieLaw />
    <UpdatePwa />
  </div>
</template>

<script>
import { MDCRipple } from '@material/ripple'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
// import Hero from '@/components/Hero.vue'
import CookieLaw from '@/components/CookieLaw.vue'
import UpdatePwa from '@/components/UpdatePwa.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    // Hero,
    CookieLaw,
    UpdatePwa
  },
  methods: {
    async update() {
      this.prompt = false
      await this.$workbox.messageSW({ type: 'SKIP_WAITING' })
    }
  },
  data() {
    return {
      prompt: false
    }
  },
  created() {
    const locale = localStorage.getItem('locale')
    const html = document.documentElement // returns the html tag

    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.showUpdateUI = true
      })
    }
    if (locale) {
      this.$i18n.locale = locale
      html.setAttribute('lang', this.$i18n.locale)
    } else if (navigator.language) {
      this.$i18n.locale = navigator.language.substring(0, 2)
      html.setAttribute('lang', this.$i18n.locale)
    }
  },
  mounted() {
    const ripple = new MDCRipple(document.querySelector('.mdc-button'))
  }
}
</script>

<style lang="scss">
@import '@material/layout-grid/mdc-layout-grid';
// @import '@material/list/mdc-list';
// @import '@material/menu-surface/mdc-menu-surface';
// @import '@material/menu/mdc-menu';
// @import '@material/select/mdc-select';

.fade-enter-active,
.fade-leave-active {
  -webkit-transition: opacity 0.6s ease;
  -o-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.demo-width-class {
  width: 400px;
}
// @import "@bootstrap/";
// @import "@/assets/css/dark";
// @import "@/assets/css/light";

.hero-items-wrapper--desktop img {
  animation-delay: 5s !important;
}
@media screen and (max-width: 576px) {
  .hero-items-wrapper--desktop-shadow {
    background: linear-gradient(
      -45deg,
      rgba(0, 0, 0, 0.22),
      rgba(255, 255, 255, 0.25)
    );
    height: 100%;
  }
  #navbarSupportedContent {
    border-radius: 4px;
    padding: 12px;
    -webkit-backdrop-filter: saturate(180%) blur(20px);
    backdrop-filter: saturate(180%) blur(20px);
    background-color: var(--navbar-bg) !important;
  }
  // .navbar {
  //   background: #fff;
  //   border-radius: 4px;
  // }
  // .navbar {
  //   margin: 23px;
  //   max-width: 1440px;
  //   padding: 0px 8px;
  //   position: relative;
  //   z-index: 2;
  // }
}
@media (max-width: 575.98px) {
  :root {
    --mdc-layout-grid-gutter-phone: 10px;
    --grid-cell: var(--grid-cell);
    // --text-color: #fff;
  }
  .mdc-layout-grid {
    padding: 0 !important;
  }
  .grid-cell {
    height: 66.56vh;
    min-height: 680px;
  }
}
:root {
  color-scheme: dark light;
  supported-color-schemes: dark light;
  --duration: 0.5s;
  --timing: ease;
  --mdc-layout-grid-gutter-desktop: 10px;
  scroll-behavior: smooth;
}

.title-cell {
  background: var(--grid-cell);
  border: var(--grid-cell-border);
  height: 100px;
  min-height: 100px;
}
.grid-cell {
  background: var(--grid-cell);
  border: var(--grid-cell-border);
  height: 82.56vh;
  min-height: 800px;
}

$primary-color: rgba(29, 29, 31, 0.72);

body {
  // background: #060606;
  // background: var(--background-color);
  background: var(--body-bg);
  -webkit-transition: background 1000ms linear;
  -ms-transition: background 1000ms linear;
  transition: background 1000ms linear;
}
div#app.router-home {
  background-color: var(--app-bg) !important;
}
#app {
  font-family: var(--paper-font-common-base_-_font-family);
  -webkit-font-smoothing: var(
    --paper-font-common-base_-_-webkit-font-smoothing
  );
  position: absolute;
  width: 100%;
  height: 100%;
  // background-image: var(--app);
  -webkit-transition: background-color 1000ms linear;
  -ms-transition: background-color 1000ms linear;
  transition: background-color 1000ms linear;
  // background: linear-gradient(
  //   -45deg,
  //   rgba(0, 0, 0, 0.22),
  //   rgba(255, 255, 255, 0.25)
  // );
  // background-color: #000;
  // background-image: url(https://www.gstatic.com/earth/images/00-earth-splash-1x-ltr.jpg),
  //   url(https://www.gstatic.com/earth/images/00-earth-splash-mask-ltr.svg),
  //   url(https://www.gstatic.com/earth/images/01-earth-splash-stars-ltr.webp);
  // background-image: url(/img/earth-view.jpg),
  //   url(https://images.unsplash.com/photo-1446941611757-91d2c3bd3d45?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=733&q=80),
  //   url(https://www.gstatic.com/earth/images/00-earth-splash-mask-ltr.svg),
  //   url(https://www.gstatic.com/earth/images/01-earth-splash-stars-ltr.webp);
  // background-position: bottom right, top left, bottom right, top right;
  // background-size: 100% 100%, 20vw, 1164px 380px, cover;
  // background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
  // background-blend-mode: lighten, lighten, normal, normal;
  // -webkit-font-smoothing: subpixel-antialiased;
  // background: url(/img/favorites/chaos.png) 0px 0px/300px 300px,
  //   linear-gradient(200deg, #1d050a 0.57%, #0e0e0e 60%) 0% 0% / cover !important;
}
.hero-items-wrapper--desktop {
  background: linear-gradient(
    -45deg,
    rgba(0, 0, 0, 0.22),
    rgba(255, 255, 255, 0.25)
  );
}
@media (min-width: 575.98px) {
  #app:before {
    display: none;
  }
  #app:after {
    display: none;
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.dropdown-menu {
  background-color: #111111;
}
.dropdown-item {
  color: #d1d1d1;
}
.dropdown-item:focus,
.dropdown-item:hover {
  color: #ffffff;
  text-decoration: none;
  background-color: transparent;
}
.navbar {
  margin: 0 auto;
  // max-width: 980px;
  max-width: 1440px;
  padding: 8px 22px;
  position: relative;
  z-index: 2;
}
.navbar-brand {
  font-family: Oswald;
  letter-spacing: 1px;
  text-transform: uppercase;
  -webkit-transition: 0.5s all ease;
  -moz-transition: 0.5s all ease;
  -o-transition: 0.5s all ease;
  transition: 0.5s all ease;
}
.navbar-brand:hover {
  text-shadow: rgb(255, 255, 255) 0px 0px 5px, rgb(255, 255, 255) 0px 0px 10px,
    #e91e63 0px 0px 20px, #e91e63 0px 0px 30px, #e91e63 0px 0px 40px,
    #e91e63 0px 0px 55px, #e91e63 0px 0px 75px;
  // animation: flash 3s 3 alternate !important;
}
#unstyle {
  padding: 0 24px;
}
#unstyle > li {
  list-style: none;
  padding: 0 12px;
}
#unstyle > li > a {
  display: block;
  color: #767676;
  transition: color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  -webkit-text-decoration-skip: ink;
  text-decoration-skip-ink: auto;
}
#unstyle > li > a > svg {
  fill: var(--text-color);
  width: 18px;
  height: 18px;
}
#unstyle > li > a > svg:hover {
  fill: #565656;
}
#unstyle > li > a > svg.tw:hover {
  fill: #1da1f2;
}
#unstyle > li > a > svg.yt:hover {
  fill: red;
}
#unstyle > li > a > svg.gh:hover {
  fill: white;
}
#unstyle > li > a > svg.dr:hover {
  fill: #ea4c89;
}
#unstyle > li > a > svg.fb:hover {
  fill: #1778f2;
}
#unstyle > li > a > svg.be:hover {
  fill: #053eff;
}
#unstyle > li > a > svg.in:hover {
  fill: #2867b2;
}
.mdc-container {
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1440px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow-x: hidden;
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 575.98px) {
  #feature2 {
    color: #42b983;
    font-size: 2em;
    padding-left: 10px;
  }
  .grid-cell {
    height: 30vh;
    max-height: 30vh;
  }
}

// // Small devices (landscape phones, 576px and up)
// @media (min-width: 576px) and (max-width: 767.98px) { ... }

// // Medium devices (tablets, 768px and up)
// @media (min-width: 768px) and (max-width: 991.98px) { ... }

// // Large devices (desktops, 992px and up)
// @media (min-width: 992px) and (max-width: 1199.98px) { ... }

// // Extra large devices (large desktops, 1200px and up)
// @media (min-width: 1200px) { ... }

.update-dialog {
  position: fixed;
  left: 50%;
  bottom: 64px;
  transform: translateX(-50%);
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 12px;
  max-width: 576px;
  color: white;
  background-color: #2c3e50;
  text-align: left;
  &__actions {
    display: flex;
    margin-top: 8px;
  }
  &__button {
    margin-right: 8px;
    &--confirm {
      margin-left: auto;
    }
  }
}
</style>
